<template>
  <q-card flat v-if="customerList.length>0">
    <q-card-section class="no-padding" v-if="isDialog">
      <q-banner inline-actions class="bg-blue text-white">
        {{ title }}
        <template v-slot:action>
          <q-btn flat v-close-popup icon="close" round/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section v-if="customerList.length>0" class="no-padding">
      <q-chip dense :size="$q.screen.lt.md?'md':'lg'" color="indigo-10" text-color="white"
              square
              label="میزان بدهی">
        <q-chip square color="red-14" text-color="white"
                v-if="!buyList"
                size="sm"
                :label="lodash.sumBy(customerList.filter(item=> item.RemCredit>0 && item.CsSpe_ID===2), item=> item.RemCredit).toLocaleString()"/>
        <q-chip square color="red-14" text-color="white"
                v-if="buyList"
                :label="lodash.sumBy(customerList.filter(item=> item.RemCredit<0), item=> Math.abs(item.RemCredit)).toLocaleString()"/>
      </q-chip>
      <q-chip dense :size="$q.screen.lt.md?'md':'lg'" color="indigo-10" text-color="white"
              square
              label="تعداد">
        <q-chip square color="red-14" text-color="white"
                size="sm"
                :label="customerList.length"/>
      </q-chip>
      <q-space v-if="$q.screen.lt.md"/>
      <vue-json-to-csv
          :json-data="customerList"
          v-if="customerList && customerList.length>0 && $store.state.roles.some(v=>['admin','can_download_list'].includes(v))">
        <q-btn label="دانلود" icon="download" color="blue" flat class="q-ml-sm">
          <download-csv
              name="customers"
              :data="customerList">
            <span></span>
          </download-csv>
          <q-tooltip>
            دانلود گزارش
          </q-tooltip>
        </q-btn>
      </vue-json-to-csv>
      <q-btn v-if="$store.state.roles.some(v=>['admin','can_send_sms'].includes(v))" label="ارسال پیامک گروهی"
             icon="send" color="indigo" flat @click="batchSMSDialog=true"/>
      <q-btn v-if="$store.state.roles.some(v=>['admin','can_print_customer_list'].includes(v))" label="چاپ گزارش"
             icon="print" color="indigo" flat @click="printCustomerList"/>
      <q-separator/>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-input v-if="isDialog" clearable autofocus v-model="filter" filled label="جستجو در لیست">
        <template v-slot:append>
          <q-btn :dense="$q.screen.lt.md" @click.stop round flat icon="settings" color="blue">
            <q-popup-proxy transition-show="flip-up" transition-hide="flip-down">
              <q-card flat>
                <q-card-section class="q-pa-xs">
                  <q-select
                      :dense="$q.screen.lt.md"
                      :options="cityListOptions"
                      filled
                      label="فیلتر بر حسب شهر"
                      v-model="selectedCities"
                      multiple
                      use-chips
                      clearable
                      use-input
                      @filter="cityFilterFn"
                      class="q-mt-xs"/>
                </q-card-section>
              </q-card>
            </q-popup-proxy>
          </q-btn>
        </template>
      </q-input>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-table
          selection="single"
          :data="customerList"
          row-key="CS_ID"
          wrap-cells
          :hide-header="$q.screen.lt.md || compactView"
          flat
          :filter="filter"
          :pagination="pagination">
        <template v-slot:header>
          <q-tr class="text-center text-bold">
            <td>شناسه</td>
            <td>نام</td>
            <td>موقعیت</td>
            <td>صنف</td>
            <td>آخرین سفارش</td>
            <td>آخرین فاکتور</td>
            <td>مبلغ معامله</td>
            <td>بدهی/بستانکاری</td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" :class="!$q.screen.lt.md?'my-class':''" v-if="!$q.screen.lt.md && !compactView"
                @mouseenter="showActionsButton(props.row)"
                @mouseleave="hideActionsButton(props.row)">
            <td class="text-center">
              <q-chip text-color="white" square clickable @click="showCustomerDetails(props.row)"
                      color="indigo"
                      class="q-ml-xs">
                <q-icon name="question_mark" v-if="props.row.HaveQuestions"/>
                {{ props.row.Cs_Code }}
                <q-tooltip v-if="props.row.HaveQuestions">
                  دارای پرسشنامه می باشد
                </q-tooltip>
              </q-chip>
              <q-space/>
              <q-chip v-if="props.row.CompName" square icon="business" size="sm">
                {{ props.row.CompName }}
              </q-chip>
            </td>
            <td>
              <q-icon name="check" color="blue-10" v-if="props.row.ValidInformation===1"/>
              {{ props.row.Cs_Name }}
              <q-badge color="pink" align="top"
                       v-if="$store.state.roles.some(v=>['admin'].includes(v))"
                       :label="props.row.CsSpe_Name" rounded/>
              <q-badge color="grey" label="آرشیو" v-if="props.row.Archived" rounded/>
              <q-space/>
              <q-rating
                  :value="(props.row.CustomerValue * 5) / 100"
                  size="1.2em"
                  :max="5"
                  icon="star_border"
                  icon-selected="star"
                  color="orange"
                  readonly
              />
              <q-space/>
              <q-chip :size="$q.screen.lt.md?'xs':'sm'" v-if="props.row.ValueKindTitle" color="red"
                      text-color="white" square flat>
                <q-icon size="sm" name="star"/>
                {{ props.row.ValueKindTitle }}
              </q-chip>
              <div class="text-caption text-grey" v-if="props.row.Cs_Address1">
                <span v-if="props.row.Cs_ShopName && props.row.Cs_ShopName!=='' && props.row.Cs_ShopName!=='None'"
                      class="text-subtitle2 text-black">{{ props.row.Cs_ShopName }}</span>
                <q-space
                    v-if="props.row.Cs_ShopName && props.row.Cs_ShopName!=='' && props.row.Cs_ShopName!=='None'"/>
                {{ props.row.Cs_Address1 }}
              </div>
              <div class="text-caption text-bold text-indigo" v-if="props.row.VisitDateTime">
                <q-chip square :label="props.row.VisitDateTime | toJalaliDateTime" size="sm"/>
                {{ props.row.VisitComment }}
              </div>
              <div class="text-caption text-grey-8" v-if="props.row.Cs_Desc && props.row.Cs_Desc!=='None'">
                {{ props.row.Cs_Desc }}
              </div>
              <div>
                <q-chip v-for="(item, index) in JSON.parse(props.row.tags)"
                        :key="`tags-${index}`"
                        icon="tag" square
                        size="sm"
                        :label="item.TagName"/>
              </div>
              <div style="height: 25px">
                <div :id="`actionRow-${props.row.Cs_Code}`" style="display: none;">
                  <q-btn round :color="props.row.ValidInformation===1 ?'indigo':'red-14'"
                         padding="none" class="q-mt-xs"
                         icon="check"
                         v-if="!isOnlySearchList && !isOnlySearchList"
                         :size="$q.screen.lt.md?'sm':'md'"
                         @click="showDetails(props.row)">
                    <q-tooltip>
                      انتخاب
                    </q-tooltip>
                  </q-btn>
                  <q-btn round color="indigo" icon="info" padding="none"
                         :size="$q.screen.lt.md?'sm':'md'"
                         @click="showCustomerDetails(props.row)">
                    <q-tooltip>
                      مشاهده پروفایل
                    </q-tooltip>
                  </q-btn>
                  <q-btn round flat color="purple" icon="insert_invitation" padding="none"
                         class="q-mt-xs"
                         :size="$q.screen.lt.md?'sm':'md'"
                         @click="showTimeLine(props.row)">
                    <q-tooltip>
                      مشاهده گزارشات مربوط
                    </q-tooltip>
                  </q-btn>
                  <q-btn round flat color="purple" icon="add_task" padding="none" class="q-mt-xs"
                         :size="$q.screen.lt.md?'sm':'md'"
                         @click="showEvent(props.row)">
                    <q-tooltip>
                      ثبت گزارش
                    </q-tooltip>
                  </q-btn>
                  <q-btn round flat color="purple" icon="list" padding="none"
                         class="q-mt-xs"
                         @click="loadGroupReports(props.row)">
                    <q-tooltip>
                      مشاهده لیست گروه کالاهایی که این ماه بر روی آن ها فعالیت داشته است
                    </q-tooltip>
                  </q-btn>
                  <q-btn round flat color="purple" icon="email" padding="none" class="q-mt-xs"
                         :size="$q.screen.lt.md?'sm':'md'"
                         v-if="$store.state.roles.some(v=>['admin','can_send_sms'].includes(v))"
                         @click="sendSMS(props.row)">
                    <q-tooltip>
                      ارسال پیامک
                    </q-tooltip>
                  </q-btn>
                  <q-btn round flat color="purple" icon="share" padding="none" class="q-mt-xs"
                         :size="$q.screen.lt.md?'sm':'md'"
                         v-if="$store.state.roles.some(v=>['admin','can_send_sms'].includes(v))"
                         @click="shareInfo(props.row)">
                    <q-tooltip>
                      به اشتراک گذاری اطلاعات از طریق پیامک
                    </q-tooltip>
                  </q-btn>
                  <q-btn round flat color="purple" icon="location_on" padding="none" class="q-mt-xs"
                         :size="$q.screen.lt.md?'sm':'md'"
                         @click="setCurrentCustomerLocation(props.row)">
                    <q-tooltip>
                      تعیین موقعیت جغرافیایی فروشگاه
                    </q-tooltip>
                  </q-btn>
                  <q-btn round flat color="purple" icon="credit_score" padding="none" class="q-mt-xs"
                         :size="$q.screen.lt.md?'sm':'md'"
                         v-if="($store.state.roles.some(v=>['can_see_customer_finance_document'].includes(v)) && (props.row.CsSpe_ID===2 || props.row.CsSpe_ID===53)) || $store.state.roles.some(v=>['admin'].includes(v))"
                         @click="showFinanceInfo(props.row)">
                    <q-tooltip>
                      مشاهده معین
                    </q-tooltip>
                  </q-btn>
                  <q-btn round flat color="purple" icon="local_phone" padding="none" class="q-mt-xs"
                         :size="$q.screen.lt.md?'sm':'md'"
                         @click="dial(props.row.Cs_Mobile, props.row)">
                    <q-tooltip>
                      نماس
                    </q-tooltip>
                  </q-btn>
                  <q-btn round flat color="purple" icon="receipt"
                         v-if="$store.state.roles.some(v=>['admin','can_entry_customer_recieve_pay'].includes(v))"
                         padding="none" @click="showReceivePayList(props.row)">
                    <q-tooltip>
                      ثبت دریافتی
                    </q-tooltip>
                  </q-btn>
                  <q-btn round flat color="purple" icon="question_mark" padding="none"
                         @click="showQuestionsDialog(props.row)"
                         v-if="($store.state.roles.some(v=>['admin','can_fill_customer_questionaire', 'can_see_questionaire'].includes(v)))">
                    <q-tooltip>
                      پرسشنامه
                    </q-tooltip>
                  </q-btn>
                  <q-btn round flat color="purple" icon="insights" padding="none"
                         v-if="$store.state.roles.some(v=>['admin','user'].includes(v))"
                         @click="showCustomerValueTrace(props.row)">
                    <q-tooltip>
                      تغییرات اعتباری
                    </q-tooltip>
                  </q-btn>
                </div>
              </div>
            </td>
            <td class="text-center">
              {{ props.row.State_Name }}
              {{ props.row.State_Name !== props.row.City_Name ? props.row.City_Name : '' }}
              {{
                props.row.Zone_Name && props.row.Zone_Name !== '' ? `منطقه ${props.row.Zone_Name}` : ''
              }}
            </td>
            <td class="text-center text-bold">
              {{ props.row.CSKind_Name }}
            </td>
            <td class="text-center">
              <q-chip square v-if="props.row.Ord_Date" color="brown" text-color="white"
                      :label="props.row.Ord_Date"/>
              <q-space/>
              <q-chip :size="$q.screen.lt.md?'xs':'sm'" clickable @click="showOrderHistory(props.row)"
                      square color="indigo" text-color="white" flat v-if="props.row.NotAcceptedOrder>0">
                سفارشات نهایی نشده
                <q-badge color="red-14" class="q-ml-xs">{{ props.row.NotAcceptedOrder }}</q-badge>
              </q-chip>
            </td>
            <td class="text-center">
              <q-chip square v-if="props.row.Fact_Date" color="brown" text-color="white"
                      :label="props.row.Fact_Date"/>
            </td>
            <td class="text-center">
              <q-chip :size="$q.screen.lt.md?'md':'md'" square color="deep-orange" text-color="white"
                      v-if="props.row.Sale_Pay > 0" icon="attach_money">
                {{ props.row.Sale_Pay | toCurrency }}
              </q-chip>
            </td>
            <td class="text-center">
              <q-chip :size="$q.screen.lt.md?'md':'md'" square
                      :color="props.row.RemCredit > 0?'red-10':'green-10'"
                      text-color="white"
                      v-if="(
                          props.row.RemCredit &&
                      props.row.RemCredit!==0) &&
                      ($store.state.roles.some(v=>['can_see_customer_finance_document'].includes(v)) && props.row.CsSpe_ID===2) ||
                      $store.state.roles.some(v=>['admin'].includes(v))"

                      icon="attach_money">
                {{ Math.abs(props.row.RemCredit) | toCurrency }} ریال
                <q-tooltip>
                  {{ props.row.RemCredit > 0 ? 'بدهی' : 'بستانکاری' }}
                </q-tooltip>
              </q-chip>
            </td>
          </q-tr>
          <q-tr :props="props" class="my-class" v-if="$q.screen.lt.md || compactView">
            <q-td>
              <q-card flat>
                <q-card-section class="no-padding">
                  <q-chip :size="$q.screen.lt.md?'sm':'sm'" square color="deep-purple-9"
                          text-color="white"
                          flat>
                    <q-icon name="check" v-if="props.row.ValidInformation===1"/>
                    {{ props.row.Cs_Name }}
                    <q-badge color="red-14" class="q-ml-xs">{{ props.row.Cs_Code }}</q-badge>
                    <q-badge color="pink" align="top"
                             v-if="$store.state.roles.some(v=>['admin'].includes(v))"
                             :label="props.row.CsSpe_Name" class="q-ml-xs" rounded/>
                  </q-chip>
                  <q-chip :size="$q.screen.lt.md?'sm':'sm'" clickable
                          @click="showOrderHistory(props.row)"
                          square color="indigo" text-color="white" flat
                          v-if="props.row.NotAcceptedOrder>0">
                    سفارشات نهایی نشده
                    <q-badge color="red-14" class="q-ml-xs">{{
                        props.row.NotAcceptedOrder
                      }}
                    </q-badge>
                  </q-chip>
                  <q-space/>
                  <q-chip :size="$q.screen.lt.md?'sm':'sm'" v-if="props.row.CSKind_Name" color="brown"
                          text-color="white" square flat>
                    <q-icon size="sm" name="business"/>
                    {{ props.row.CSKind_Name }}
                  </q-chip>
                  <q-chip :size="$q.screen.lt.md?'xs':'xs'" v-if="props.row.ValueKindTitle"
                          color="red"
                          text-color="white" square flat>
                    <q-icon size="sm" name="star"/>
                    {{ props.row.ValueKindTitle }}
                  </q-chip>
                  <q-rating
                      :value="(props.row.CustomerValue * 5) / 100"
                      size="1.2em"
                      :max="5"
                      icon="star_border"
                      icon-selected="star"
                      color="orange"
                      readonly
                  />
                  <q-space/>
                  <q-chip :size="$q.screen.lt.md?'sm':'sm'" v-if="props.row.City_Name" color="brown"
                          text-color="white" square flat>
                    <q-icon size="sm" name="business"/>
                    {{ props.row.City_Name }}
                  </q-chip>
                  <q-chip :size="$q.screen.lt.md?'sm':'sm'" v-if="props.row.Zone_Name"
                          color="brown-14"
                          text-color="white" square flat>
                    <q-icon size="sm" name="business"/>
                    {{ props.row.Zone_Name }}
                  </q-chip>
                  <q-chip v-if="props.row.CompName " :size="$q.screen.lt.md?'sm':'sm'" square icon="business">
                    {{ props.row.CompName }}
                  </q-chip>
                  <q-space/>
                  <q-chip :size="$q.screen.lt.md?'sm':'sm'" square color="deep-orange"
                          text-color="white"
                          v-if="props.row.Sale_Pay > 0" icon="attach_money">{{
                      props.row.Sale_Pay | toCurrency
                    }}
                  </q-chip>
                  <q-chip :size="$q.screen.lt.md?'sm':'sm'" square
                          :color="props.row.RemCredit > 0?'red-10':'green-10'"
                          :label="props.row.RemCredit > 0?'بدهی:':'بستانکاری:'"
                          text-color="white"
                          v-if="(
                          props.row.RemCredit &&
                      props.row.RemCredit!==0) &&
                      ($store.state.roles.some(v=>['can_see_customer_finance_document'].includes(v)) && props.row.CsSpe_ID===2) ||
                      $store.state.roles.some(v=>['admin'].includes(v))"
                          icon="attach_money">
                    {{ Math.abs(props.row.RemCredit) | toCurrency }} ریال
                  </q-chip>
                  <q-space/>
                  <q-chip size="sm" v-if="props.row.Ord_Date" square text-color="white"
                          color="blue-10" label="آخرین سفارش:"
                          icon="calendar_today">
                    <q-badge class="q-ml-xs" color="red" text-color="white"
                             :label="props.row.Ord_Date"/>
                  </q-chip>
                  <q-chip size="sm" v-if="props.row.Fact_Date" square text-color="white"
                          color="blue-10" label="آخرین فاکتور:"
                          icon="calendar_today">
                    <q-badge class="q-ml-xs" color="red" text-color="white"
                             :label="props.row.Fact_Date"/>
                  </q-chip>
                </q-card-section>
                <q-card-section class="no-padding" v-if="props.row.VisitDateTime ">
                  <span class="text-bold text-indigo q-ml-xs">({{ props.row.VisitDateTime | toJalaliDateTime }})</span>
                  <q-space/>
                  <span class="text-caption text-justify">{{ props.row.VisitComment }}</span>
                </q-card-section>
                <q-card-actions align="left" class="no-padding">
                  <q-btn-group flat>
                    <q-btn round :color="props.row.ValidInformation===1 ?'indigo':'red-14'"
                           padding="none" class="q-mt-xs"
                           icon="check"
                           v-if="!isOnlySearchList"
                           @click="showDetails(props.row)">
                      <q-tooltip>
                        انتخاب
                      </q-tooltip>
                    </q-btn>
                    <q-btn round flat color="purple" icon="info" padding="none" class="q-mt-xs"
                           @click="showCustomerDetails(props.row)">
                      <q-tooltip>
                        مشاهده پروفایل
                      </q-tooltip>
                    </q-btn>
                    <q-btn round flat color="purple" icon="insert_invitation" padding="none"
                           class="q-mt-xs"
                           @click="showTimeLine(props.row)">
                      <q-tooltip>
                        مشاهده گزارشات مربوط
                      </q-tooltip>
                    </q-btn>
                    <q-btn round flat color="purple" icon="list" padding="none"
                           class="q-mt-xs"
                           @click="loadGroupReports(props.row)">
                      <q-tooltip>
                        مشاهده لیست گروه کالاهایی که این ماه بر روی آن ها فعالیت داشته است
                      </q-tooltip>
                    </q-btn>
                    <q-btn round flat color="purple" icon="add_task" padding="none" class="q-mt-xs"
                           @click="showEvent(props.row)">
                      <q-tooltip>
                        ثبت گزارش
                      </q-tooltip>

                    </q-btn>
                    <q-btn round flat color="purple" icon="email" padding="none" class="q-mt-xs"
                           v-if="$store.state.roles.some(v=>['admin','can_send_sms'].includes(v))"
                           @click="sendSMS(props.row)">
                      <q-tooltip>
                        ارسال پیامک
                      </q-tooltip>
                    </q-btn>
                    <q-btn round flat color="purple" icon="share" padding="none" class="q-mt-xs"
                           v-if="$store.state.roles.some(v=>['admin','can_send_sms'].includes(v))"
                           @click="shareInfo(props.row)">
                      <q-tooltip>
                        به اشتراک گذاری اطلاعات طرف معامله از طریق پیامک
                      </q-tooltip>
                    </q-btn>
                    <q-btn round flat color="purple" icon="location_on" padding="none"
                           class="q-mt-xs"
                           @click="setCurrentCustomerLocation(props.row)">
                      <q-tooltip>
                        تعیین موقعیت جغرافیایی طرف معامله
                      </q-tooltip>
                    </q-btn>
                    <q-btn round flat color="purple" icon="credit_score" padding="none"
                           class="q-mt-xs"
                           v-if="($store.state.roles.some(v=>['can_see_customer_finance_document'].includes(v)) && props.row.CsSpe_ID===2) || $store.state.roles.some(v=>['admin'].includes(v))"
                           @click="showFinanceInfo(props.row)">
                      <q-tooltip>
                        مشاهده معین
                      </q-tooltip>
                    </q-btn>
                    <q-btn round flat color="purple" icon="local_phone" padding="none"
                           class="q-mt-xs"
                           @click="dial(props.row.Cs_Mobile, props.row)">
                      <q-tooltip>
                        برقراری تماس
                      </q-tooltip>
                    </q-btn>
                    <q-btn round flat color="purple" icon="question_mark" padding="none"
                           @click="showQuestionsDialog(props.row)"
                           v-if="($store.state.roles.some(v=>['admin','can_fill_customer_questionaire'].includes(v)))">
                      <q-tooltip>
                        پرسشنامه
                      </q-tooltip>
                    </q-btn>
                  </q-btn-group>

                </q-card-actions>
              </q-card>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="showCustomerFullInfo">
      <CustomerInfo :selectedCustomer="this.selectedCustomer"
                    :buy-list="buyList"
                    @customer-updated="customerUpdated"/>
    </q-dialog>
    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="showOrderHistoryList">
      <q-card>
        <q-card-section class="row items-center q-pb-none">
          <div>
            <div class="text-bold">سوابق سفارشات <i class="text-indigo-14">{{
                selectedCustomer.Cs_Name
              }}</i></div>
            <q-badge align="top" class="bg-red-14"><i>شناسه(</i><b>{{
                selectedCustomer.Cs_Code
              }}</b><i>)</i>
            </q-badge>
          </div>
          <q-space/>
          <q-btn icon="close" flat round dense v-close-popup/>
        </q-card-section>
        <q-card-section>
          <OrderHistory default-sale-state="0" :order-history-list="orderHistoryList"/>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="showSMSPanel">
      <SMSPanel :customer="selectedCustomer" :share="share" @sms_sended="sms_sended"/>
    </q-dialog>
    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="showVisitLogDialog">
      <visit-log :selectedCustomer="this.selectedCustomer"/>
    </q-dialog>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showEventDialog">
      <CUVisitLog @event-added="closeEventDialog" :selected-customer="this.selectedCustomer"/>
    </q-dialog>
    <q-dialog
        v-model="showFinanceInfoDialog"
        :maximized="$q.screen.lt.md">
      <CustomerFinanceInfo :customer-info="selectedCustomer"/>
    </q-dialog>
    <q-dialog v-model="showCallPanelDialog">
      <CallPanel :customer-info="selectedCustomer" :call-number="callNumber"/>
    </q-dialog>
    <q-dialog v-model="customerReceivePayList" :maximized="$q.screen.lt.md">
      <CustomerReceiveList :customer-info="selectedCustomer"/>
    </q-dialog>
    <q-dialog v-model="batchSMSDialog">
      <SMSPanel :customers="customerList" :share="false" :multiple="true" @sms_sended="sms_sended"/>
    </q-dialog>
    <q-dialog v-model="customerQuestionaire" maximized>
      <CustomerQuestions :customer-info="selectedCustomer"/>
    </q-dialog>
    <q-dialog v-model="customerValueDialog">
      <CustomerRFMTrace :customer-info="selectedCustomer"/>
    </q-dialog>
  </q-card>
</template>

<script>
import EventBus from "@/event-bus";
import {mapActions} from "vuex";
import OrderHistory from "@/components/customers/OrderHistory";
import SMSPanel from "@/components/callCenter/SMSPanel";
import VisitLog from "@/components/customers/VisitLog";
import CUVisitLog from "@/components/customers/CUVisitLog";
import CustomerFinanceInfo from "@/components/customers/CustomerFinanceInfo";
import CallPanel from "@/components/callCenter/CallPanel";
import CustomerReceiveList from "@/components/customers/CustomerReceiveList";
import VueJsonToCsv from 'vue-json-to-csv'
import CustomerQuestions from "@/components/CustomerQuestions/CustomerQuestions";
import CustomerRFMTrace from "@/components/customers/CustomerRFMTrace.vue";

export default {
  name: "CustomersList",
  components: {
    CustomerRFMTrace,
    CustomerQuestions,
    CustomerReceiveList,
    CallPanel, CustomerFinanceInfo, CUVisitLog, VisitLog, SMSPanel, OrderHistory,
    CustomerInfo: () => import("@/components/customers/CustomerInfo"), VueJsonToCsv
  },
  props: {
    isBuyAndSaleList: {
      type: Boolean,
      default: () => false
    },
    buyList: {
      type: Boolean
    },
    title: {
      type: String,
      required: false,
      default: 'لیست'
    },
    isOnlySearchList: {
      type: Boolean,
      defaults: false
    },
    isDialog: {
      type: Boolean,
      required: true,
      default: false
    },
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    compactView: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      customerValueDialog: false,
      customerQuestionaire: false,
      cityListOptions: [],
      cityList: [],
      selectedCities: [],
      batchSMSDialog: false,
      filter: '',
      customerReceivePayList: false,
      showFinanceInfoDialog: false,
      share: false,
      showVisitLogDialog: false,
      showEventDialog: false,
      showSMSPanel: false,
      customerList: [],
      selectedCustomer: '',
      showCustomerFullInfo: false,
      showCustomerEditForm: false,
      orderHistoryList: [],
      showOrderHistoryList: false,
      pagination: {
        sortBy: 'title',
        rowsPerPage: 10
      },
      callNumber: '',
      showCallPanelDialog: false
    }
  },
  methods: {
    ...mapActions({
      ShowOrderHistory: 'Customers/getOrderHistory',
      setLocation: 'Customers/set_current_location',
      getCustomerInfo: 'Customers/get_customer_info',
      printRequest: 'Customers/customerPrintRequest'
    }),
    printCustomerList() {
      this.printRequest({
        customerIds: this.customerList.map(c => c.Cs_ID).join(',')
      }).then(async (res) => {
        await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با مشتریان/چاپ لیست مشتریان?rs:Format=PDF&RequestID=${res.requestIds}&rc:Parameters=False&rc:Zoom=Page Width`)
      })
    },
    async loadGroupReports(rowInfo) {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/%DA%AF%D8%B2%D8%A7%D8%B1%D8%B4%D8%A7%D8%AA%20%D9%85%D8%B1%D8%AA%D8%A8%D8%B7%20%D8%A8%D8%A7%20%D9%85%D8%B4%D8%AA%D8%B1%DB%8C%D8%A7%D9%86/%DA%AF%D8%B2%D8%A7%D8%B1%D8%B4%20%D9%81%D8%B1%D9%88%D8%B4%20%D9%85%D8%A7%D9%87%D8%A7%D9%86%D9%87%20%DA%AF%D8%B1%D9%88%D9%87%20%DA%A9%D8%A7%D9%84%D8%A7%20%DA%A9%D8%A7%D8%B1%20%DA%A9%D8%B1%D8%AF%D9%87%20%D9%88%20%DA%A9%D8%A7%D8%B1%20%D9%86%DA%A9%D8%B1%D8%AF%D9%87%20%D8%A8%D9%87%20%D8%A7%D8%B2%D8%A7%DB%8C%20%DB%8C%DA%A9%20%D9%85%D8%B4%D8%AA%D8%B1%DB%8C%20%D8%AF%D8%B1%20%D8%B3%D8%A7%D9%84%20%D8%AC%D8%A7%D8%B1%DB%8C?rs:Format=PDF&Code=${rowInfo.Cs_ID}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    showCustomerValueTrace(args) {
      this.selectedCustomer = args
      this.customerValueDialog = true
    },
    showQuestionsDialog(args) {
      this.selectedCustomer = args
      this.customerQuestionaire = true
    },
    customerUpdated(args) {
      this.selectedCustomer = args
      this.customerList = this.customerList.filter(item => item.Cs_ID !== args.Cs_ID)
      this.customerList.unshift(args)
    },
    cityFilterFn(val, update) {
      if (val === '') {
        update(() => {
          this.cityListOptions = this.cityList
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.cityListOptions = this.cityList.filter(v => v.toLowerCase().indexOf(needle) > -1)
      })
    },
    showActionsButton(row) {
      this.selectedCustomer = row;
      const actionRow = document.getElementById(`actionRow-${row.Cs_Code}`)
      actionRow.style.display = 'block'
    },
    hideActionsButton(row) {
      const actionRow = document.getElementById(`actionRow-${row.Cs_Code}`)
      actionRow.style.display = 'none'
    },
    selectedRow(row) {
      this.selectedCustomer = row;
    },
    showReceivePayList(row) {
      this.selectedCustomer = row;
      this.customerReceivePayList = true;
    },
    dial(number, rowInfo) {
      this.callNumber = number;
      this.selectedCustomer = rowInfo
      this.showCallPanelDialog = true;
    },
    showEvent(row) {
      this.selectedCustomer = row;
      this.showEventDialog = true
    },
    showTimeLine(row) {
      this.selectedCustomer = row;
      this.showVisitLogDialog = true;
    },
    closeEventDialog() {
      this.showEventDialog = false
    },
    sms_sended() {
      this.showSMSPanel = false
      this.batchSMSDialog = false
    },
    shareInfo(userInfo) {
      this.share = true;
      this.selectedCustomer = userInfo
      this.showSMSPanel = true
    },
    showFinanceInfo(row) {
      this.selectedCustomer = row;
      this.showFinanceInfoDialog = true;
    },
    showOrderHistory(row) {
      this.ShowOrderHistory(row.Cs_ID).then((res) => {
        this.selectedCustomer = row;
        this.orderHistoryList = res.data;
        this.showOrderHistoryList = true;
      });
    },
    showDetails(row) {
      if (row.ValidInformation !== 1) {
        this.$q.notify({
          message: 'اطلاعات طرف معامله نادرست است، لطفا ابتدا اطلاعات طرف معامله را اصلاح نموده  و سپس اقدام یه ثبت سفارش نمایید',
          color: 'negative',
          position: 'top',
          type: 'negative',
          multiLine: true
        });
      } else {
        if (row.NotAcceptedOrder !== 0) {
          this.$q.notify({
            message: 'طرف معامله دارای سفارش تایید نشده می باشد',
            color: 'deep-orange',
            position: 'top',
            type: 'deep-orange',
            multiLine: true
          });
        }
        this.selectedCustomer = row;
        this.$emit('customerSelected', row)
        EventBus.$emit('invoke-selected-customer', row);
        EventBus.$emit('invoke-customer-search-result-event', []);
      }
    },
    showCustomerDetails(row) {
      this.getCustomerInfo(row.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0];
        this.showCustomerFullInfo = true;
      })
    },
    sendSMS(userInfo) {
      this.share = false
      this.selectedCustomer = userInfo
      this.showSMSPanel = true
    },
    setCurrentCustomerLocation(customerInfo) {
      this.$getLocation({
        timeout: Infinity
      }).then(coordinates => {
        this.setLocation({
          Cs_ID: customerInfo.Cs_ID,
          latitude: coordinates.lat,
          longitude: coordinates.lng,
          accuracy: coordinates.accuracy
        }).then(() => {
          this.$q.notify({
            message: 'موقعیت جغرافیایی طرف معامله به ثبت رسید',
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
        });
      }).catch(() => {
        this.$q.notify({
          message: 'امکان دریافت موقعیت جغرافیایی طرف معامله وجود ندارد',
          color: 'negative',
          position: 'top',
          type: 'negative'
        });
      });
    },
  },
  watch: {
    selectedCities: function (value) {
      if (value) {
        this.customerList = this.items.filter(item => item.City_Name !== null && value.includes(item.City_Name));
      } else {
        this.customerList = this.items
      }
    }
  },
  created() {
    if (this.items.length > 0) {
      this.customerList = this.items;
      this.cityList = this.lodash.uniq(this.customerList.map(item => item.City_Name))
      this.cityListOptions = this.cityList
    }
  },
  mounted() {
    if (this.items.length === 0) {
      EventBus.$on('invoke-customer-search-result-event', payload => {
        this.customerList = payload;
      });
      EventBus.$on('invoke-selected-customer', payload => {
        this.selectedCustomer = payload;
      });
    }
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>
